import { Component, Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const headingFields = [
  ...moleculeHeadingFields,
  {
    name: 'visuallyHidden',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'Renders ONLY the heading text, invisible to visitors but read by search engines. Use with H1 when the page title is an image (e.g. the Connect logo). Eyebrow, body, buttons and section styles are skipped. In the editor the block shows a placeholder so you can select it.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

export const headingConfig = {
  name: 'heading',
  inputs: headingFields,
} satisfies Component;

export type ComponentHeadingConfigProps = GenerateBuilder<typeof headingFields>;
